import { StyleSheet, View } from "react-native";

const AnimatedFlashListCellRenderer = (props: any) => {
  const { children, style, ...rest } = props;

  return (
    <View {...rest} style={StyleSheet.flatten(style)}>
      {children}
    </View>
  );
};

export default AnimatedFlashListCellRenderer;
